export default "/fonts/zenloop-regular-webfont.svg?3f3ca297c0ef45d1c0fd5005b0969437";